// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5929) return "static/chunks/5929.b928fa49c8824417.js";
	if (chunkId === 4210) return "static/chunks/4210.224e6e897a82c168.js";
	if (chunkId === 1963) return "static/chunks/1963.d270babb9c2a85d2.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"155":"b801a6fb070b1d2b","1197":"046659c46d081f70","1599":"90061b18d0ccc5db","4159":"3c65a6674f4356f0","5110":"cf8b82a0ee8a44af","7256":"b0aa0869d4b23dd5","9837":"c1029fe7f692715f"}[chunkId] + ".js";
};